import {getTrackingStatus} from './api';
export const trackRequirement=getTrackingStatus;
